<div class="workflow-details" c-toggle="showDetails" c-toggle-options="{type: 'fade'}">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>